import { theme } from 'Assets/Styles/theme'

export const styles = {
  liveMapWrapper: {
    margin: '0 40px',
    position: 'relative',
    minHeight: '100px',
  },
  loadingWrapper: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    color: '#fff',
  },
  liveMapFilterRow: {
    margin: '10px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterGroup: {
    display: 'flex',
    '& > div': {
      marginLeft: '35px',
    },
  },
  liveMapHeader: {
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '26px',
    lineHeight: '30px',
    color: theme.colors.primary,
  },
  checkboxRow: {
    margin: '12px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',

    '& .livemap-checkbox': {
      marginRight: '60px',

      label: {
        fontSize: '14px',
        lineHeight: '20px',
        color: theme.colors.black,
        fontWeight: 'normal',
      },
    },
  },
  presetsGroup: {
    paddingBottom: '20px',
    position: 'relative',
  },
  timeMessage: {
    position: 'absolute',
    bottom: 0,
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.colors.black,
    fontWeight: 'normal',
  },
}
